import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertDeletedEvent } from "@/components/Alert";
import { DescriptionModal } from "@/components/DescriptionModal/DescriptionModal";
import { MapaDeEventos } from "@/components/EventMap";
import { RegisterIncidentsDialog } from "@/components/Menu/RegisterIncidentsDialog";
import { BackButtonTitle } from "@/components/ui/back-button-title";
import { INCIDENT_CATEGORIES } from "@/constants/incidentCategories";
import { useIsDesktop } from "@/hooks/useBreakpoint";
import { cn } from "@/utils/cn";
import { Button } from "@opala-ds/react";
import { useWebgate } from "@xvia/webgate-connect";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export const Events = () => {
    const navigate = useNavigate();
    const isDesktop = useIsDesktop(768);
    const [isRegisterDialogOpen, setIsRegisterDialogOpen] = useState(false);
    const [selectedIncident, setSelectedIncident] = useState(null);
    const { accessToken } = useWebgate();
    const handleOptionModalChange = (open, category, to) => {
        if (open && category && to) {
            setSelectedIncident({ category, to });
            setIsRegisterDialogOpen(false);
            return;
        }
        setSelectedIncident(null);
        setIsRegisterDialogOpen(true);
    };
    const getContainerClassName = (desktop, hasAccessToken) => {
        if (!desktop) {
            return "flex-col w-full";
        }
        if (hasAccessToken) {
            return "flex-row w-[70%]";
        }
        return "flex-row w-[35%]";
    };
    const containerClassName = getContainerClassName(isDesktop, !!accessToken);
    return (_jsxs(_Fragment, { children: [_jsx(RegisterIncidentsDialog, { isOpen: isRegisterDialogOpen, onClose: () => setIsRegisterDialogOpen(false), categories: INCIDENT_CATEGORIES, onOptionModalChange: handleOptionModalChange }), selectedIncident && (_jsx(DescriptionModal, { isOpen: true, onClose: () => handleOptionModalChange(false), category: selectedIncident.category, to: selectedIncident.to })), _jsx("div", { className: "max-w-screen-lg mx-auto", children: _jsxs("div", { className: "py-4", children: [_jsx(BackButtonTitle, { title: "Visualiza\u00E7\u00E3o de Eventos" }), _jsxs("div", { children: [_jsx(AlertDeletedEvent, {}), _jsx(MapaDeEventos, { zoom: 14 }), _jsx("div", { className: "flex justify-center mt-4", children: _jsxs("div", { className: `flex gap-4 ${containerClassName} `, children: [accessToken && (_jsx(Button, { id: "btn-visualizar-historico-registros", className: isDesktop
                                                    ? "flex-1 min-w-fit truncate"
                                                    : "min-w-fit truncate", variant: "outline", onClick: () => navigate("/historico"), children: "Visualizar Hist\u00F3rico de Registros" })), _jsx(Button, { id: "btn-registrar-eventos", className: cn("bg-[#034EA2]", isDesktop ? "flex-1" : "min-w-fit truncate"), onClick: () => setIsRegisterDialogOpen(true), children: "Registrar Eventos" })] }) })] })] }) })] }));
};
